import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LearningGameCoreService } from './learning-game-core.service';
import { LearningGameSelectorComponent } from './learning-game-selector/learning-game-selector.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [LearningGameSelectorComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  providers: [LearningGameCoreService],
  exports: [LearningGameSelectorComponent],
})
export class LearningGameCoreModule {}
